(
    function () {
      $(".play-button").on("click", function () {
        $(".colonna-1-content .immagini-copertina").addClass("hidden");
        $(".colonna-1-content .video-vimeo").removeClass("hidden");
        $(this).addClass("hidden");
        
      })
      
      $(".chiudi-video").on("click", function () {
        $(".colonna-1-content .immagini-copertina").removeClass("hidden");
        $(".colonna-1-content .video-vimeo").addClass("hidden");
        $(".play-button").removeClass("hidden");

      })

        $('.slider-related-collabs-content').slick({
            dots: false,
            infinite: true,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  arrows: true,
                  prevArrow: $('.frecce-slider .freccia-prev'),
                  nextArrow: $('.frecce-slider .freccia-next'),
                }
              }
            ]
          });
    }
)()